/**
 * Helper function for exhaustive checks of discriminated unions.
 */
export function assertNever(value) {
    throw new Error(`Unhandled discriminated union member: ${JSON.stringify(value)}`);
}
//# sourceMappingURL=ts-helpers.js.map